import { Link } from 'gatsby';
import React from 'react';

const faqQuestions = [
    {
        q: 'What is laser hair removal?',
        a: (
            <>
                Laser hair removal is a popular alternative to waxing and shaving. This is largely due to the fact that
                laser hair removal provides permanent results<sup>&dagger;</sup> and is{' '}
                <Link to="/lp/cost/">less expensive than maintaining a waxing and shaving routine</Link> for a lifetime.
                Additionally, there’s no recovery time needed after a treatment—so no more doing the waxing-waddle or
                battling razor burn.{<br />} {<br />}
                Our treatments are safe, and all of our procedures are performed by Authorized Candela Practitioners. We
                use <Link to="/process/">FDA-cleared lasers</Link> that are tailored to your{' '}
                <Link to="/areas">specific skin type &amp; hair color</Link>.
            </>
        ),
    },
    {
        q: 'Why Milan Laser Hair Removal?',
        a: (
            <>
                We're the experts in laser hair removal, it's all we do. PLUS we include our Unlimited Package™ with
                every body area.{<br />}
                {<br />}Milan is the largest laser hair removal company in the nation and the only one that offers the
                Unlimited Package: unlimited treatments for life at no additional cost. While the average person needs 7
                to 10 treatments to be up to 95% hair free, with us you'll always be covered no matter how many
                treatments you need.{<br />}
                {<br />}The bottom line: You'll never pay for hair removal on the same body area again.{<br />}
                {<br />}
                <Link to="/process/beforeafter" className="text-milan-navy">
                    Before & After
                </Link>
                {<br />}
                <Link to="/our-machine" className="text-milan-navy">
                    Our Technology
                </Link>
                {<br />}
                <Link to="/process/compare" className="text-milan-navy">
                    Hair Removal Techniques
                </Link>
                {<br />}
            </>
        ),
    },
    {
        q: 'Does it hurt?',
        a: 'Most clients describe the sensation similar to the feeling of being snapped with a rubber band. Compared to waxing, the treatment has very little discomfort. Our state of the art laser uses a cooling technology to safely and effectively cool the treated skin, which decreases discomfort.',
    },
    {
        q: 'How much does it cost? ',
        a: (
            <>
                The average person who shaves their legs and underarms spends upwards of $10,000 over a lifetime on
                razors, shaving cream, exfoliants, and more. If you wax your bikini area, you spend over $18,000 on a
                lifetime of salon appointments. These costs are only for temporary results, while laser hair removal
                gives you permanent results!{<br />}
                {<br />} Milan Laser offers monthly specials and affordable laser hair removal payment plans with 0%
                interest available to fit anyone’s monthly budget, plus unlimited treatments for life at no additional
                costs with their exclusive Unlimited Package™.
            </>
        ),
    },
    {
        q: 'How permanent is laser hair removal?',
        a: 'Most of our clients are up to 95% hair-free in treated areas within 7 to 10 treatments. Hormones, pregnancy and the odd stubborn hair that just won’t quit, is why we include our Unlimited Package with every purchase—so you never pay touch-up fees or need to buy additional sessions.',
    },
    {
        q: 'What does unlimited package mean?',
        a: (
            <>
                With our Unlimited Package (included with every area), most people need between 7 to 10 treatments to
                see up to 95% hair reduction. The best part of this package – besides never shaving again – is that no
                matter how many treatments you need, it’s the same price!{<br />}
                {<br />} At Milan, you’ll never worry about buying additional treatments or paying touch-up fees. Unlike
                other places, once you’ve purchased an area with us, it’s covered for the rest of your life.{<br />}
                {<br />}Initially, each treatment is completed 5 weeks apart.
            </>
        ),
    },
    {
        q: 'Do you have laser hair removal specials?',
        a: (
            <>
                Say goodbye to unwanted hair on your – underarms, bikini area, lip/chin, legs and back – with one of our
                great deals! <Link to="#consult">Schedule a free consult</Link> today to take advantage of current
                specials.{<br />}
                {<br />}
                We believe you deserve to have hair-free skin at a price you can afford. That's why in addition to
                offering great specials, we approve everyone for affordable payment plans.{<br />}
                {<br />}
                <Link to="/specials" className="text-milan-navy">
                    Learn more about the payment plan options
                </Link>
                {<br />}
                <Link to="/process/faqs" className="text-milan-navy">
                    Laser Hair Removal FAQs
                </Link>
                {<br />}
                <Link to="/company/about-us" className="text-milan-navy">
                    About Milan Laser
                </Link>
                {<br />}
            </>
        ),
    },
    {
        q: 'What makes Milan Laser the nation’s leading expert?',
        a: (
            <>
                With over 400+ locations in 38 states, Milan Laser Hair Removal makes getting smooth skin more
                accessible than ever. Every purchase comes with our exclusive Unlimited Package™, offering all the
                treatments you need at no additional cost. Plus, everyone qualifies for our flexible financing options,
                available at any of our convenient locations. At Milan Laser, we make it simple to say goodbye to
                unwanted hair — guaranteed.{<br />}
                {<br />}Founded in 2012 by board-certified medical doctors, Milan Laser performs over 90,000 treatments
                each month. We provide state-of-the-art laser treatments in a safe, relaxing environment.{<br />}
                {<br />}
                <Link className="text-milan-navy" to="/locations">
                    Find Your Nearest Location
                </Link>{' '}
            </>
        ),
    },
    {
        q: 'Does laser hair removal work with PCOS?',
        a: `Yes! Laser hair removal is an effective treatment for unwanted hair removal and managing PCOS hair growth. It targets hair follicles, which can be particularly bothersome in areas like the upper lip, chin, cheeks, and more, significantly reducing growth over time. Many clients report incredible results, often seeing a decrease in hair density, hair thickness, and regrowth as soon as their first treatment.`,
    },
];

export default faqQuestions;
